import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import A11yOptions from "@/components/comm-generator/A11yOptions";
import { Control, UseFormWatch } from "react-hook-form";

interface AccessibilityOptionsToggleProps {
  control: Control<any>;
  watch: UseFormWatch<any>;
  t: (key: string) => string;
}

export function AccessibilityOptionsToggle({
  control,
  watch,
  t,
}: AccessibilityOptionsToggleProps) {
  return (
    <>
      <FormField
        control={control}
        name="showAccessibilityOptions"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between">
            <FormLabel className="">{t("accessibility.label")}</FormLabel>
            <FormControl>
              <Switch
                className="!mt-0"
                checked={field.value === "yes"}
                onCheckedChange={(checked) =>
                  field.onChange(checked ? "yes" : "no")
                }
              />
            </FormControl>
          </FormItem>
        )}
      />
      {watch("showAccessibilityOptions") === "yes" && <A11yOptions />}
    </>
  );
}
